import React, { useState } from "react";
import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";

const TenantKYCModal = ({
  onClose,
  settingsData,
  editNotiSettingsMutate,
  editNotiSettingsLoading,
}) => {
  const [settings, setSettings] = useState({
    whatsApp: settingsData?.whatsApp === 1,
    sms: settingsData?.sms === 1,
    rentReminder: settingsData?.rentReminder === 1,
    onboardWelcome: settingsData?.onboardWelcome === 1,
  });

  const toggleSetting = (key, isEnabled) => {
    const updatedState = { ...settings, [key]: !settings[key] };
    setSettings(updatedState);
    editNotiSettingsMutate({key, isEnabled});
  };

  return (
    <div className="bg-white w-full h-full flex flex-col">
      <div className="flex items-center justify-between bg-[#0078BD] py-6 px-4">
        <Title className="text-white">Notification Settings</Title>
        <button onClick={onClose}>
          <MdClose color="white" size={24} />
        </button>
      </div>

      <div className="px-4 h-full flex flex-col justify-between pb-4 relative">
        <Wrapper>
          <Section>
            <SectionTitle>Settings</SectionTitle>
            <ToggleRow>
              <div>
                <Label>WhatsApp Notification</Label>
                <Description>
                  Enable this to receive important updates and <br />
                  notifications through WhatsApp messages.
                </Description>
              </div>
              <Toggle
                checked={settings.whatsApp}
                onChange={() => toggleSetting("whatsApp", !settings.whatsApp)}
              />
            </ToggleRow>
            <ToggleRow>
              <div>
                <Label>SMS Notification</Label>
                <Description>
                  Enable this to receive important updates and <br />
                  notifications through SMS.
                </Description>
              </div>
              <Toggle
                checked={settings.sms}
                onChange={() => toggleSetting("sms", !settings.sms)}
              />
            </ToggleRow>
            <ToggleRow>
              <div>
                <Label>Automated Payment Reminders</Label>
                <Description>
                  Enabling this allows tenants to receive payment <br />
                  and due reminders.
                </Description>
              </div>
              <Toggle
                checked={settings.rentReminder}
                onChange={() => toggleSetting("rentReminder", !settings.rentReminder)}
              />
            </ToggleRow>
            <Row>
              <div>
                <Label>Tenant Onboarding Welcome</Label>
                <Description>
                  When enable, a welcome massage will be sent to <br />
                  new tenants.
                </Description>
              </div>
              <Toggle
                checked={settings.onboardWelcome}
                onChange={() => toggleSetting("onboardWelcome", !settings.onboardWelcome)}
              />
            </Row>
          </Section>
        </Wrapper>

        {/* <BtnWrapper>
          <SecondaryButton>Copy settings to other properties</SecondaryButton>
          <PrimaryButton>Edit</PrimaryButton>
        </BtnWrapper> */}
      </div>
    </div>
  );
};

const Wrapper = tw.div`grid gap-6 my-6`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
const Section = tw.div``;
const SectionTitle = tw.h2`text-lg font-semibold text-gray-900`;
const ToggleRow = tw.div`flex justify-between py-2 border-b border-gray-200 items-center`;
const Row = tw.div`flex justify-between py-2 items-center`;
const Label = tw.span`text-gray-900`;
const Description = tw.p`text-gray-400 text-sm md:mx-1`;
const BtnWrapper = tw.div`flex gap-3`;
const PrimaryButton = tw.button`bg-[#0078BD] w-2/5 text-white px-4 py-2 rounded-lg hover:bg-[#65adf0]`;
const SecondaryButton = tw.button`bg-white w-3/5 border border-[#0078BD] text-[#0078BD] font-medium px-4 py-1 rounded-lg`;

const Toggle = ({ checked, onChange }) => (
  <label className="relative inline-flex items-center cursor-pointer">
    <input
      type="checkbox"
      className="sr-only peer"
      checked={checked}
      onChange={onChange}
    />
    <div className="w-11 h-6 bg-gray-300  rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
  </label>
);

export default TenantKYCModal;